module.exports = __webpack_public_path__ + "h5/img/summer-navc33.7b4f4d66.png";